import styled from 'styled-components';
import { colorUsage, getSpacing, transitionDuration } from 'stylesheet';
var GenericBlockToggle = styled.span.withConfig({
  displayName: "GenericBlockTogglestyle__GenericBlockToggle",
  componentId: "sc-145g7p9-0"
})(["display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin-left:", ";cursor:pointer;transition:color ", ";& path{transition:fill ", ";fill:", ";}&:hover{color:", ";& path{fill:", ";}}"], getSpacing(0.5), transitionDuration["default"], transitionDuration["default"], function (_ref) {
  var toggled = _ref.toggled;
  return true === toggled ? colorUsage.inlineToolbarToggleHoverForeground : colorUsage.iconForeground;
}, colorUsage.inlineToolbarToggleHoverForeground, colorUsage.inlineToolbarToggleHoverForeground);
export default GenericBlockToggle;